import { debounce, MonoTypeOperatorFunction, NEVER, Observable, race, timer } from "rxjs";

/// Create an operator that will debounce the source observable, yet will fire immediately if the circuit breaker observable emits.
export function saveDebounce<T>(circuitBreaker: Observable<any> = NEVER): MonoTypeOperatorFunction<T> {
    return debounce(_ => race(timer(2000), circuitBreaker));
}
